/**
 * @file [path].tsx
 *
 * @fileoverview Renders organization root pages.
 */
import JobiqoOrganizationDetailPath, {
  getServerSideProps,
} from '~/jobiqo/pages/organization/detail';

export default JobiqoOrganizationDetailPath;
export { getServerSideProps };
